<template>
  <div id="map">
    <template v-if="!!this.google && !!this.map">
      <slot v-if="reload" />
    </template>
  </div>
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  props: {
    config: Object,
    apikey: String,
  },
  data() {
    return {
      google: null,
      map: null,
      reload: true,
    };
  },
  watch: {
    config: {
      handler() {
        this.loadMap();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadMap();
  },
  methods: {
    initMap() {
      const mapContainer = this.$el;
      const { Map } = this.google.maps;
      this.map = new Map(mapContainer, this.config);
    },
    loadMap() {
      this.reload = false;
      const loader = new Loader({
        apiKey: this.apikey,
        version: "weekly",
        libraries: ["places"],
      });

      loader.load().then((google) => {
        this.google = google;
        this.reload = true;
        this.initMap();
      });
    },
  },
};
</script>
